export const GAMES_FOLDER = 'games';

export interface GameMetadata {
  name: string;
  description: string;
  tags: string[];
  thumbnailUrl: string;
}

export interface GameRecord {
  gameId: string;
  ownerId: string;
  createdAt: string;
  updatedAt: string;
  published: boolean;
  canModify: boolean;
  metadata: GameMetadata;
}

export interface DeleteGameResponse {
  message: string;
}

export const GameQueryParamsKeys = {
  onlyMyGames: 'onlyMyGames',
  published: 'published',
} as const;

export const GameQueryParamsValues = {
  All: 'all',
  Unpublished: 'unpublished',
  Published: 'published',
} as const;

export type GameQueryParamsValues = (typeof GameQueryParamsValues)[keyof typeof GameQueryParamsValues];

export type GameAssetAction = 'read' | 'write' | 'delete' | 'resumable';

export interface GetGameAssetHashesResponse {
  hashes: Record<string, string>;
}

export interface SetGameAssetContentHashResponse {
  success: boolean;
}

export interface GenerateGameAssetSignedUrlResponse {
  gameId: string;
  filePath: string;
  contentType: string;
  action: GameAssetAction;
  signedUrl: string;
  bucketFilePath: string;
}
